<template>
    <v-container fluid>
        <v-row dense>
            <v-col cols="12">
                <v-card :loading="!loaded">
                    <v-card-title>
                        Clientes <v-icon style="margin-left: 0.25em" v-on:click="getData">mdi-reload</v-icon>
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="Search"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                            :headers="headers"
                            :items="clients"
                            :search="search">
                        <template v-slot:item.action="{ item }">
                            <router-link :to="'/clientdata/'+item.userID">
                                <v-icon>mdi-eye</v-icon>
                            </router-link>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
        <new-client-form :get-data="getData"/>
    </v-container>
</template>

<script>
    import newClientForm from "../components/clients/newClientForm";
    export default {
        name: "Clients",
        components:{newClientForm},
        data() {
            return {
                clients: [],
                headers: [
                    {
                        text: 'Cliente',
                        align: 'start',
                        sortable: false,
                        value: 'socialName',
                    },
                    {text: 'nombre fiscal', value: 'fiscalName'},
                    {text: 'CIF/NIF', value: 'CIF'},
                  {text:'Teléfono',value:'phone'},
                    {text: 'email', value: 'email'},
                    {text: 'Acciones', value: 'action', sortable: false}
                ],
                search: '',
                loaded: false
            }
        },
        mounted() {
            this.getData();
        },
        methods: {
            getData() {
                this.loaded = false;
                let url = this.base_url + '/invV2/admin/clientes/' + localStorage.token;
                this.axios.get(url).then(response => {
                    this.clients = response.data.clients;
                    this.loaded = true;
                });
            }
        }
    }
</script>

<style scoped>
    .clientLink {
        text-decoration: none;
        color: black;
        font-weight: bold;
    }
</style>